<script setup lang="ts">
interface HeaderLinkInterface {
    title: string
    link: string
}

const props = defineProps<HeaderLinkInterface>()
</script>

<template>
    <div
        class="main-page-header-link"
    >
        <div class="main-page-header__divider" />
        <a
            :href="props.link"
            class="main-page-header-link__inner"
            tabindex="0"
        >
            {{ props.title }}
        </a>
    </div>
</template>

<style>
    .main-page-header-link {
        display: flex;
        align-items: center;

        block-size: 24px;

        font-size: 14px;
        text-transform: capitalize;
    }

    .main-page-header-link__inner {
        color: rgb(var(--v-theme-header));
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
</style>
